// extracted by mini-css-extract-plugin
module.exports = {"buildings":"buildings__2ROAc","avatar":"avatar__2QKmn","chip":"chip__3HDXd"};